import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a3a740a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a3a740a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4a3a740a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a740a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/app/components/Breadcrumb.vue').default,BreadcrumbStructuredData: require('/app/components/BreadcrumbStructuredData.vue').default,VehicleHero: require('/app/components/VehicleHero.vue').default,SocialShareButtons: require('/app/components/SocialShareButtons.vue').default,VehicleHeadlightRamp: require('/app/components/VehicleHeadlightRamp.vue').default,VehicleHeadlightTypeCard: require('/app/components/VehicleHeadlightTypeCard.vue').default,Configurator: require('/app/components/Configurator.vue').default,VehicleHeadlightExclusionButton: require('/app/components/VehicleHeadlightExclusionButton.vue').default,VehicleHeadlightExcludedProducts: require('/app/components/VehicleHeadlightExcludedProducts.vue').default,ProductList: require('/app/components/ProductList.vue').default,ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default,PartnerFittingLink: require('/app/components/PartnerFittingLink.vue').default,ClientsReviewsSlider: require('/app/components/ClientsReviewsSlider.vue').default,SkeepersCarousel: require('/app/components/SkeepersCarousel.vue').default})
